import { doPrivateGetRequest } from "./requests"

export const getAudioSecureUrl = (_meets_id, _token) => {
    const path = `/audio/api/secure-section-url/${_meets_id}`
    return doPrivateGetRequest(path, _token)
}

export const getAudioDownloadUrl = (_meets_id, _token) => {
    const path = `/audio/api/secure-section-url/${_meets_id}`
    return doPrivateGetRequest(path, _token)
}